import { user } from '@/api/auth';
import { get } from 'lodash';

// States.
export const state = {
  checked: false,
  user: null,
  userModes: [
    'labeling',
    'uploading',
    'curating',
    'browsing',
    'referencing'
  ],
  currentUserMode: 'labeling',
  modesInaccessibleToMinors: [
    'uploading',
    'curating',
    'browsing',
    'referencing'
  ],
  modeActions: {
    labeling: ['section', 'comment', 'leaderboard'],
    uploading: ['section', 'leaderboard'],
    curating: ['section', 'leaderboard'],
    browsing: ['section', 'comment', 'leaderboard'],
    referencing: ['section', 'leaderboard'],
  },
  modesPermissions: {
    labeling: ['play'],
    curating: ['review_artifact'],
    uploading: ['upload_artifact'],
    browsing: ['upload_artifact'],
    referencing: ['reference_artifact'],
  }
}

// Getters.
export const getters = {
  emailVerified: state => get(state, ['user', 'email_verified_at'], null) !== null,
  availableModes: state => state.userModes,
  isNotMinor: state => get(state, ['user', 'is_minor'], true) === false,
  isMinor: state => get(state, ['user', 'is_minor'], true) === true,
  hasDateOfBirthRecorded: state => get(state, ['user', 'date_of_birth'], null) !== null,
  hasAnyArtifactPassedCuration: state => get(state, ['user', 'has_any_artifact_passed_curation'], false) === true,
  modeActions: state => get(state.modeActions, state.currentUserMode)
}

// Mutations.
export const mutations = {
  UPDATE_CHECKED: (state, { checked }) => state.checked = checked,

  UPDATE_USER: (state, { user }) => state.user = user,

  UPDATE_CURRENT_USER_MODE: (state, { mode }) => state.currentUserMode = mode
}

// Actions.
export const actions = {
  setAuthed: ({ commit }, { checked }) => commit('UPDATE_CHECKED', { checked }),

  fetchUser: async ({ commit }) => commit('UPDATE_USER', { user: (await user()).data.data }),

  setUserMode: ({ commit }, { mode }) => commit('UPDATE_CURRENT_USER_MODE', { mode })
}
